import { ContentFlexComponent } from "components/flexComponents/Content/typings";
import CardWithLinkEditorial from "components/flexComponents/Content/factory/impl/editorials/CardWithLinkEditorial";

export class ThemeSelectorCard extends CardWithLinkEditorial {
  /* istanbul ignore next */
  constructor(editorial: ContentFlexComponent) {
    super(editorial);
  }

  public getEditorialItemClassName = (): string => "all-y-gutter-three themeSelectorCard";
}

export default ThemeSelectorCard;
